const array=[
  {
    name: 'Emily',
    age:'27',
    job:'Photographer',
    url:'https://images.unsplash.com/photo-1525134479668-1bee5c7c6845?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fA%3D%3D&w=1000&q=80'
  },
  {
    name:'John',
    age:'25',
    job:'Model', 
    url:'https://photowhoa.com/2015/wp-content/uploads/2016/08/photo-1523913507744-1970fd11e9ff.jpg'
  },
  {
    name:'Jazmine',
    age:'23',
    job:'Student',
    url:'https://i.pinimg.com/564x/87/7b/01/877b01f7092146efb33a6848e786d892.jpg'
  },
  {
    name:'Jack',
    age:'26',
    job:'UI/UX developer',
    url:'https://i.pinimg.com/736x/fa/24/de/fa24decb9fb75a2f35c43e60a2f98e87.jpg'
  },
  {
    name: 'Jessica',
    age:'26',
    job:'Marketing Manager',
    url:'https://cyber-privacy.net/wp-content/uploads/thispersondoesnotexist.com-image01-1024x1024.jpg'
  },
  {
    name:'Aditya',
    age:'27',
    job:'Full-Stack Web Developer',
    url:'https://xsgames.co/randomusers/assets/avatars/male/74.jpg'
  }
];


export default array
